module.exports = __webpack_public_path__ + "media/social/link-website-25d8c2c5.png";